import { FC } from 'react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/Form';
import RadioGroup, { RadioItem } from '@/components/ui/RadioGroup';

import { useLingui } from '@lingui/react';
import { useFormContext } from 'react-hook-form';

export const BUSINESS_ACTIVITY = {
  YES: 'yes',
  NO: 'no',
} as const;

export const BUSINESS_ACTIVITY_NAME = 'business_activity';
export const BUSINESS_ACTIVITY_NAME_COMPLEMENTARY =
  'business_activity_complementary';

interface Props {
  name?: string;
  isComplementary?: boolean;
}

export const RadioGroupBusinessActivity: FC<Props> = ({
  name,
  isComplementary = false,
}) => {
  const fieldName =
    name ??
    (isComplementary
      ? BUSINESS_ACTIVITY_NAME_COMPLEMENTARY
      : BUSINESS_ACTIVITY_NAME);

  const { i18n } = useLingui();
  const { control } = useFormContext();

  return (
    <FormField
      control={control}
      name={fieldName}
      rules={{
        required: {
          value: true,
          message: i18n.t('Uzupełnij to pole, aby przejść dalej'),
        },
      }}
      render={({ field }) => (
        <FormItem>
          <FormLabel>
            {i18n.t('Czy prowadzisz działalność gospodarczą?')}
          </FormLabel>
          <FormControl>
            <RadioGroup
              {...field}
              layout={'horizontal'}
              data-testid="radio-group-business-activity"
            >
              <RadioItem
                value={BUSINESS_ACTIVITY.YES}
                label={i18n.t('Tak')}
                data-testid="radio-item-business-activity-yes"
              />
              <RadioItem
                value={BUSINESS_ACTIVITY.NO}
                label={i18n.t('Nie')}
                data-testid="radio-item-business-activity-no"
              />
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
